import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'lg' | 'xl';
  variant?: 'solid' | 'brass-edge';
  className?: string;
};
export function CtaButton({
  children,
  href = '#pricing',
  size = 'lg',
  variant = 'solid',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'xl' ? 'px-6 py-4 text-[16px] sm:px-10 sm:py-5 sm:text-lg' : 'px-6 py-4 text-[15px] sm:px-8 sm:text-base';
  const edge = variant === 'brass-edge' ? 'ring-1 ring-brass/70 ring-offset-2 ring-offset-forest' : '';
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2.5 rounded-xl bg-sage font-sans font-semibold text-white shadow-card transition-[background-color,transform,box-shadow] duration-200 ease-out hover:bg-sage-dark hover:shadow-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 motion-reduce:transition-none sm:w-auto ${sizing} ${edge} ${className}`} data-id="element-108" data-mp="10an0wwzamuzi">
      <span data-id="element-109" data-mp="35zim0d3qk2pk">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0" strokeWidth={1.75} aria-hidden="true" data-id="element-110" data-mp="39y7vvvpkf24g" />
    </a>;
}